const styles = () => ({
  documentContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '20px',
    alignItems: 'center',
  },
  fileName: {
    fontSize: '1rem',
    fontWeight: '600',
    padding: '0 10px',
  },
  viewFile: {
    cursor: 'pointer',
  },
  fileIconHolder: {
    display: 'flex',
    alignItems: 'center',
  },
});
export default styles;
